import React from 'react';
import NavCollapse from "../NavCollapse";
import NavItem from "../NavItem";

function navGroup (props) {
    let navItems = '';
    if (props.group.children) {
        const groups = props.group.children;
        navItems = Object.keys(groups).map(item => {
            const newItem = groups[item];
            switch (newItem.type) {
                case 'collapse':
                    return <NavCollapse key={newItem.id} collapse={newItem} type="main" />;
                case 'item':
                    return <NavItem layout={props.layout} key={newItem.id} item={newItem} />;
                default:
                    return false;
            }
        });
    }

    return (
        <>
            <li key={props.group.id} className="nav-item pcoded-menu-caption"><label>{props.group.title}</label></li>
            {navItems}
       </>
    );
};

export default navGroup;
